<template>
  <div class="kyc-notification-overlay">
    <div class="kyc-modal" :style="styles">
      <div class="kyc-close">
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="close"
        >
          <path
            d="M11 1.10786L9.89214 0L5.5 4.39214L1.10786 0L0 1.10786L4.39214 5.5L0 9.89214L1.10786 11L5.5 6.60786L9.89214 11L11 9.89214L6.60786 5.5L11 1.10786Z"
            fill="black"
          />
        </svg>
      </div>
      <div
        class="kyc-content px-4"
        v-if="approve"
        style="width: 100%; position: relative"
      >
        <br />
        <div>Are you such you want to approve this merchant?</div>
        <br />

        <div>
          Please, make sure documents are provided and valid, before you
          proceed.
        </div>
        <br />
        <br />

        <div style="display: flex; justify-content: space-between">
          <button
            @click="close"
            class="btn woven-border-only woven-red bg-white"
          >
            <span>Cancel</span>
          </button>
          <button @click="onContinue" class="btn btn--primary btn--filter">
            <span>Yes, Approve</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KycNotification",
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    onContinue: Function,
    approve: Boolean,
    styles: String,
  },
  setup(props, { root }) {
    const store = root.$store;

    const close = () => {
      props.onClose();
    };
    return {
      close,
    };
  },
};
</script>

<style lang="scss">
.kyc-notification-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  .kyc-modal {
    width: 440px;
    background: #ffffff;
    border-radius: 4px;
    padding: 1rem 2rem;

    font-family: Calibre;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    color: #0b1b36;

    h1 {
      font-size: 24px;
      line-height: 29px;
      color: #0b1b36;
      font-style: normal;
      font-weight: normal;
    }
    &.large {
      width: 667px;
    }

    .kyc-close {
      height: 20px;
      padding: 10px 0;
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
      img,
      svg {
        border-radius: 50%;
        height: 20px;
        width: 20px;
        padding: 5px;
        &:hover {
          background: rgba(255, 255, 255, 0.4);
          color: #000000;
          filter: invert(1);
        }
      }
    }
    .kyc-content {
      height: 90%;
      padding-bottom: 1.2rem;
      .kyc-fade-p {
        color: #919eab;
        font-family: Calibre;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        padding: 2.2rem 0;
      }
    }
    .kyc-url-woven {
      color: #e00b5b !important;
      padding: 1rem;
      display: block;
    }
    .kyc-kickback {
      height: 230px;
    }
  }
}
</style>
